export default {
    'msg001':                   'Hello',
    'msg002':                   'Welcome',
    'msg003':                   'Ka-may-ari',
    'msg004':                   'Help us improve, Ka-may-ari. How would you rate our service?',
    'msg005':                   'Skip',
    'msg006':                   'Maybe next time',
    'msg007':                   'Session Timeout',
    'msg008':                   'Oops! Something went wrong. You have been logged out from your current session',
    'msg009':                   'Didn\'t receive a code?',
    'msg010':                   'Branch Log Out',
    'msg011':                   'You are about to log out this PSO from the PAFCPIC Information Kiosk system. If you did not intend to perform this action or need assistance, please contact the PAFCPIC IT Division.',
    'msg012':                   'No activity detected. We will log you out in',
    'msg013':                   'seconds',
    'msg014':                   'unless you confirm you\'re still with us',
    'msg015':                   'Are you sure you want to log out?',
    'msg016':                   'Are you still there, Ka-may-ari?',
    'msg017':                   'Yay! Let us know what you liked',
    'msg018':                   'What can be improved?',
    'btn001':                   'Ok',
    'btn002':                   'Proceed',
    'btn003':                   'Back',
    'btn004':                   'Log out',
    'btn005':                   'Balance',
    'btn006':                   'All',
    'btn007':                   'Summary',
    'btn008':                   'Submit',
    'btn009':                   'Verify',
    'btn010':                   'Cancel',
    'btn011':                   'Stay logged in',
    'btn012':                   'No',
    'btn013':                   'Yes',
    'btn014':                   'Continue',
    'btn015':                   'Not Me',
    'stp001':                   'Tap to Start',
    'lop001':                   'Please select your desired login option',
    'lop002':                   'PAPSI Mobile Account',
    'lop003':                   'Account/Serial No.',
    'lop004':                   'QR Code',
    'pma001':                   'Please fill out your PAPSI Mobile login credentials',
    'pma002':                   'Enter your PAPSI Mobile Account',
    'pma003':                   'Enter your username',
    'pma004':                   'Enter your password',
    'asn001':                   'Please fill out the following login details',
    'asn002':                   'Enter your Account/Serial Number',
    'asn003':                   'Enter',
    'asn004':                   'Enter Account Number',
    'asn005':                   'Enter Serial Number',
    'qrc001':                   'Please position your QR code within the frame',
    'qrc002':                   'Scan QR Code',
    'enp001':                   'Please enter your PIN from your PAPSI Mobile App',
    'enp002':                   'Enter your Personal Identification Number (PIN)',
    'enp003':                   'Enroll your PIN before proceeding to use the kiosk',
    'enp004':                   'Confirm your account details',
    'enp005':                   'Is this you, Ka-may-ari?',
    'enp006':                   'Please re-type your PIN to confirm',
    'enp007':                   'Please update your PIN. The PIN initially provided to you is temporary and must be changed for security purposes.',
    'enp008':                   'Please update your temporary PIN',
    'enp009':                   'Welcome back, Ka-May-Ari!',
    'enp010':                   'For security purposes, you are required to update your temporary PIN before proceeding.',
    'smp001':                   'Please select your desired transaction',
    'smp002':                   'Balance Inquiry',
    'smp003':                   'View Member Info',
    'smp004':                   'Queueing Number',
    'smp005':                   'Need Help?',
    'bip001':                   'Please select your desired balance inquiry',
    'bip002':                   'Share Capital',
    'bip003':                   'Savings',
    'bip004':                   'Loans',
    'led001':                   'You may view your transactions here',
    'led002':                   'as of',
    'led003':                   'Showing',
    'led004':                   'Results',
    'led005':                   'Hide Zero Balance',
    'led006':                   'Show Zero Balance',
    'led008':                   'Date',
    'led009':                   'Reference',
    'led010':                   'Debit',
    'led011':                   'Credit',
    'led012':                   'Balance',
    'led013':                   'of',
    'led014':                   'Hide All Balances',
    'led015':                   'Show All Balances',
    'led016':                   'If you have other inquiries, please proceed to any PSO personnel for assistance',
    'mip001':                   'You may view your member information here',
    'mip002':                   'Account No',
    'mip003':                   'Serial No',
    'mip004':                   'Member Type',
    'mip005':                   'Mobile Number',
    'mip006':                   'Email Address',
    'mip007':                   'Birthdate',
    'mip008':                   'TIN',
    'mip009':                   'Enter your new mobile number',
    'mip010':                   'Enter your new email address',
    'mip011':                   'Add your Birthdate',
    'mip012':                   'Add your TIN',
    'mip013':                   'Membership Information',
    'mip014':                   'No birthday provided',
    'mip015':                   'No TIN provided',
    'mip016':                   'Your changes have been successfully updated',
    'mip017':                   'Enter your old PIN',
    'mip018':                   'Enter your new PIN',
    'mip019':                   'Confirm your new PIN',
    'mip020':                   'Enter your PIN',
    'mip021':                   'Confirm your PIN',
    'mip022':                   'Enroll your PIN before proceeding to use the kiosk',
    'has001':                   'How can we help you, Ka-may-ari?',
    'has002':                   'Help and Support',
    'has003':                   'End-User License Agreement',
    'has004':                   'Privacy Policy',
    'has005':                   'Contact Support',
    'has006':                   'Please read our End-User License Agreement',
    'has007':                   'Please read our Privacy Policy',
    'has008':                   'Send us any inquiries, comments, or suggestions',
    'has009':                   'Office Hours',
    'otp001':                   'Resend',
    'otp002':                   'Resend in',
    'otp003':                   'seconds',
    'otp004':                   'OTP Verification',
    'otp005':                   'Input the OTP sent to your email and/or mobile number to verify your identity',
    'load01':                   'Please wait'
}